import React from 'react'
import { Radar } from 'react-chartjs-2'
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from 'chart.js'

ChartJS.register(RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend)

const RadarChart = ({ chartData, custom, hasBenchmark }) => {
  const options = {
    plugins: {
      datalabels: {
        display: false,
      },
      legend: {
        display: false,
      },
    },
    elements: {
      line: {
        borderWidth: 3,
      },
    },

    scales: {
      r: {
        pointLabels: {
          padding: 35,
          font: {
            size: '14px',
          },
        },
        suggestedMin: 0,
        suggestedMax: 100,
        ticks: {
          stepSize: 20,
          callback: function (value, index, values) {
            return value < 100 ? value : ''
          },
          backdropColor: 'transparent',
        },
        grid: {
          circular: true,
          color: ['#E5E5E5'],
        },
        backgroundColor: '#F7F9FA',
        beginAtZero: true,
      },
    },
  }
  if (custom) {
    options.maintainAspectRatio = false
    options.responsive = true
  }
  chartData.datasets.forEach((dataset, index) => {
    dataset.pointStyle = index === 0 && hasBenchmark ? 'circle' : false
  })

  return (
    <Radar
      data={chartData}
      options={{
        ...options,
      }}
    />
  )
}

export default RadarChart
